import DeliveryDateSelectorButton from '@/components/deal/delivery-date/delivery-date-selector-button';
import DealDeliveryPreferenceSelectorButton from '@/components/deal/delivery-preference/deal-delivery-preference-selector-button';
import DeliveryQueueSelectorButton from '@/components/deal/delivery-queue/delivery-queue-selector-button';
import { FinanceManagerSelectorButton } from '@/components/deal/finance-manager/finance-manager-selector-button';
import PickupDateSelectorButton from '@/components/deal/pickup-date/pickup-date-selector-button';
import { DealPrioritySelectorButton } from '@/components/deal/priority/deal-priority-selector-button';
import { SalesRepSelectorsButton } from '@/components/deal/sales-reps/sales-reps-selectors-button';
import { DealStageSelectorButton } from '@/components/deal/stage/deal-stage-selector-button';
import { DealStatusSelectorButton } from '@/components/deal/status/deal-status-selector-button';
import { PDKLongHaulIcon } from '@/components/ui/pdk-icons';
import { Deal } from '@/models/registry';
import { observer } from 'mobx-react-lite';

const MobileSubheader = observer(({ deal }: { deal: Deal }) => {
  const dealShortId = deal.short_id;

  return (
    <div className="flex flex-col w-full border-b z-30">
      <div className="flex flex-row flex-wrap p-2 gap-1 items-center">
        <DealStatusSelectorButton
          id={deal.id}
          shortId={dealShortId}
          value={deal.status}
          side="bottom"
          className="pl-1"
        />
        <DealStageSelectorButton
          id={deal.id}
          value={deal.stage}
          side="bottom"
          shortId={dealShortId}
          className="pl-1"
        />
        <DealPrioritySelectorButton
          id={deal.id}
          value={deal.priority}
          side="bottom"
          useAbbreviation
        />
        <DealDeliveryPreferenceSelectorButton
          dealId={deal.id}
          delivery_preference={deal.delivery_preference}
          side="bottom"
          align="end"
          useAbbreviation
        />
        <PickupDateSelectorButton
          dealId={deal.id}
          pickup_date={deal.pickup_date}
          side="bottom"
          align="end"
          hideYear
        />
        <DeliveryDateSelectorButton
          dealId={deal.id}
          delivery_date={deal.delivery_date}
          side="bottom"
          align="end"
          hideYear
          icon={<PDKLongHaulIcon />}
        />
        {deal.vehicle_listing && (
          <DeliveryQueueSelectorButton
            dealId={deal.id}
            pickupDate={deal.pickup_date}
            delivery_date={deal.delivery_date}
            // vehicle={deal.vehicle_listing}
            date_added={deal.date_added_to_customer_delivery_queue}
            useAbbreviation
          />
        )}
        <FinanceManagerSelectorButton
          id={deal.id}
          value={deal.finance_manager}
          side="bottom"
          align="end"
          useAbbreviations
        />
        {deal.primary_sales_rep &&
          deal.secondary_sales_rep &&
          deal.vehicle_listing &&
          deal.primary_customer && (
            <SalesRepSelectorsButton
              dealShortId={dealShortId}
              dealId={deal.id}
              orientation="horizontal"
              side="bottom"
              align="end"
              primarySalesRep={deal.primary_sales_rep}
              secondarySalesRep={deal.secondary_sales_rep}
              vehicle={deal.vehicle_listing}
              primaryCustomerFullName={deal.primary_customer.full_name}
              useAbbreviations
            />
          )}
      </div>
    </div>
  );
});

export default MobileSubheader;
